export default __webpack_public_path__ + "static/media/studentRealCase2-sc.68da5207.jpg";